import React from "react";
import { Phone, ArrowUpRight } from "lucide-react";

const Hero = ({ onBook }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden bg-white"
    >
      {/* Full-bleed sunset coastal photograph */}
      <div className="absolute inset-0 -z-20">
        <img
          src="/hero-sunset.webp"
          alt="Coastal sunset with warm skies and gentle turquoise waves over sandy beach"
          data-testid="hero-image"
          className="h-full w-full object-cover object-center"
          loading="eager"
          style={{ filter: "brightness(1.1) saturate(1.06)" }}
        />
      </div>

      {/* Contrast wash — dark on the left where the copy sits, fades to none on the right */}
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(90deg, rgba(4,20,32,0.62) 0%, rgba(4,20,32,0.42) 32%, rgba(4,20,32,0.18) 55%, rgba(4,20,32,0.05) 75%, rgba(4,20,32,0.00) 100%), linear-gradient(180deg, rgba(4,20,32,0.15) 0%, rgba(4,20,32,0) 45%)",
        }}
      />

      <div className="relative mx-auto grid min-h-[720px] max-w-7xl grid-cols-1 items-center px-6 pb-40 pt-32 md:px-12 md:pb-56 md:pt-40 lg:grid-cols-12 lg:min-h-[860px]">
        {/* LEFT — anchored content on the darker side */}
        <div className="lg:col-span-7 fade-up">
          {/* eyebrow */}
          <div className="mb-8 flex items-center gap-4">
            <span
              className="h-px w-12"
              style={{ backgroundColor: "#FFFFFF", opacity: 0.6 }}
              aria-hidden="true"
            />
            <p
              data-testid="hero-eyebrow"
              className="font-body text-[11px] font-semibold uppercase tracking-[0.32em] text-white/90"
            >
              Wilmington, NC · Cape Fear Coast
            </p>
          </div>

          {/* Slogan — white for max contrast against the warm sunset, blue accent stays brand-consistent */}
          <h1
            data-testid="hero-heading"
            className="font-heading font-black leading-[0.95] tracking-tight text-5xl text-white sm:text-6xl lg:text-7xl xl:text-[5.75rem]"
            style={{ textShadow: "0 2px 24px rgba(0,0,0,0.28)" }}
          >
            Coastal Fresh.
            <br />
            <span
              style={{
                color: "#CBD5E1",
                textShadow:
                  "0 2px 6px rgba(0,0,0,0.45), 0 8px 28px rgba(0,0,0,0.35)",
              }}
            >
              Commercial Clean.
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl font-body text-base font-medium leading-relaxed text-white/90 md:text-lg"
            style={{ textShadow: "0 1px 12px rgba(0,0,0,0.35)" }}
          >
            Deep-foam sanitation, odor elimination, and hospital-grade
            disinfection for commercial restrooms across the Cape Fear coast.
            Quietly thorough. Fully insured.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <button
              data-testid="hero-book-btn"
              onClick={onBook}
              className="group inline-flex h-14 items-center justify-center gap-3 rounded-none bg-white px-9 font-body text-sm font-bold uppercase tracking-[0.14em] transition-opacity hover:opacity-90"
              style={{ color: "#0B3D4E" }}
            >
              Request a Quote
              <ArrowUpRight
                size={16}
                strokeWidth={2.2}
                className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
            </button>
            <a
              href="tel:9102369971"
              data-testid="hero-call-btn"
              className="inline-flex items-center gap-3 font-body text-sm font-bold uppercase tracking-[0.14em] text-white"
            >
              <Phone size={15} strokeWidth={2.2} />
              <span className="border-b border-white/80 pb-1">910-236-9971</span>
            </a>
          </div>
        </div>

        {/* RIGHT — left empty to let the sunset breathe */}
        <div className="hidden lg:col-span-5 lg:block" aria-hidden="true" />
      </div>

      {/* Wavy shoreline divider */}
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 z-10"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 1440 180"
          preserveAspectRatio="none"
          className="block h-24 w-full md:h-36 lg:h-40"
        >
          <path
            d="M0,90 C220,160 420,30 640,80 C860,130 1080,180 1300,120 C1360,100 1400,90 1440,95 L1440,180 L0,180 Z"
            fill="#ffffff"
            opacity="0.55"
          />
          <path
            d="M0,120 C200,180 400,80 640,110 C880,140 1080,200 1280,150 C1360,132 1410,124 1440,128 L1440,180 L0,180 Z"
            fill="#ffffff"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
